import { render, staticRenderFns } from "./ChurnGoodbyePage.vue?vue&type=template&id=2648ab12&scoped=true"
import script from "./ChurnGoodbyePage.vue?vue&type=script&lang=js"
export * from "./ChurnGoodbyePage.vue?vue&type=script&lang=js"
import style0 from "./ChurnGoodbyePage.vue?vue&type=style&index=0&id=2648ab12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2648ab12",
  null
  
)

export default component.exports